import { required } from "../../shared/src/codecs/types/required";
import { uuid } from "../../shared/src/codecs/types/uuid";

export const ListingId = required({
    listing_id: uuid(),
});
export type TListingIdCodec = typeof ListingId;